/**
 * `live` — clases en vivo multi-provider (Diseño B, F2-B).
 *
 * Añadir un proveedor = implementar `MeetingProvider` + `register()`. El resto
 * de la app (pantalla en vivo, ajustes, catálogo) NO cambia.
 */
export * from "./registry";
// F3-G: espejo cliente de la ventana de join + constructor de opciones del embed.
export * from "./window";
export * from "./embed";
export { jitsiProvider } from "./providers/jitsi";
export { zoomProvider } from "./providers/zoom";
export { meetProvider } from "./providers/meet";
export { customLinkProvider } from "./providers/custom_link";
export { makeExternalProvider } from "./providers/external";

import type { FeatureManifest } from "../academy/country/packs";
import { customLinkProvider } from "./providers/custom_link";
import { jitsiProvider } from "./providers/jitsi";
import { meetProvider } from "./providers/meet";
import { zoomProvider } from "./providers/zoom";
import {
  MeetingProviderRegistry,
  meetingProviderToFeatureManifest,
  type MeetingProvider,
} from "./registry";

/** Los proveedores de clases en vivo que embarca Space (v1). */
export const baseMeetingProviders: readonly MeetingProvider[] = [
  jitsiProvider,
  zoomProvider,
  meetProvider,
  customLinkProvider,
];

/** Registro con los proveedores base cargados. Punto de partida para la app. */
export function defaultMeetingProviderRegistry(): MeetingProviderRegistry {
  return new MeetingProviderRegistry().registerAll(baseMeetingProviders);
}

/**
 * Manifests catalog-ready de los proveedores de vivo (keys `media.provider.<id>`).
 * Misma forma que `countryPackManifests()` — F2-D los consume en `gen:features`.
 */
export function mediaProviderManifests(): FeatureManifest[] {
  return baseMeetingProviders.map((p) => meetingProviderToFeatureManifest(p.manifest));
}
